import { isType } from './resources/attribute'
import { GetResourceGql } from '../services/useApi'
import { Catalog, CatalogGql, PartialProduct, Product, ProductAttribute } from '../utils/types/Product'
import { isDefined } from '../utils/types/misc'
import { FeatureType, FeatureValueType } from '../utils/types/featureType'

export const getFeatureValueType = (fv: FeatureType | string): FeatureValueType => {
  const numberInputTypes = [
    'celsius', 'liters', 'decibel', 'kilogram', 'metre',
    'number', 'percentage', 'time', 'lumens', 'grams-per-square-metre',
  ]
  const singleInputTypes = ['size']
  const booleanInputTypes = ['boolean']

  if (numberInputTypes.includes(fv)) {
    return 'number'
  }
  if (booleanInputTypes.includes(fv)) {
    return 'boolean'
  }
  if (singleInputTypes.includes(fv)) {
    return 'single'
  }
  // Default to multi
  return 'multi'
}

export const isSeparateValueList = (values: ProductAttribute[]): boolean => (
  // Currently only colors, sizes and materials are saved as separate value lists
  values.some((attr) => (
    ['color', 'material', 'size'].includes(attr['attribute.code'])))
)

export const getCurrentValue = (value: ProductAttribute[], currentType: string | string[]) => {
  const highlightedFeatureType = value.find((attr) => (
    isType(attr, currentType) && attr?.['product.lists.type']?.startsWith('highlight')))

  if (highlightedFeatureType && highlightedFeatureType['product.lists.type']?.includes('|')) {
    const [, valueCode] = highlightedFeatureType['product.lists.type'].split('|')
    const highlightedFeatureValue = value.find((attr) => attr['attribute.code'] === valueCode)

    if (highlightedFeatureValue) {
      return {
        attribute: highlightedFeatureType,
        label: `${highlightedFeatureType['attribute.code']}-${highlightedFeatureValue['attribute.code']}`,
      }
    }
  }

  return {
    attribute: highlightedFeatureType,
    label: highlightedFeatureType?.['attribute.code'] || '',
  }
}

export const getAllFeatureTypes = (
  catalog: Catalog[],
  getResourceGraphql: GetResourceGql,
) => {
  const selectedLevel2Categories = catalog?.filter((cat) => cat['catalog.level'] === 2)
  const filter = {
    '==': {
      'catalog.code': selectedLevel2Categories.map((cat) => cat['catalog.code']).sort(),
    },
  }
  const paramsWithAttribute = `filter:"${JSON.stringify(filter).replace(/"/g, '\\"')}", include: ["attribute"], limit: 1000`

  const { data: catalogWithFeatures } = getResourceGraphql<Catalog, CatalogGql>(
    selectedLevel2Categories.length ? 'catalog' : null,
    paramsWithAttribute,
  )

  return catalogWithFeatures.flatMap((cat) => cat.attribute).filter(isDefined)
}
